import React from "react"
import { Link } from "react-router-dom";

export const Footer = () => (
    <div className="footer">
        <div className="container">
            <div className="row">
                <div className="col-12 col-sm-4 col-xl-4  ">
                    <Link className="footer__logo" to="/">Riselio</Link><br /><br />
                </div>
                <div className="col-6 col-sm-4 col-xl-4 sitemap">
                    <Link to="/cara-pakai">Cara Pakai</Link>
                    <Link to="/faq">FAQ</Link>
                    <Link to="/daftar-supplier">Menjadi Supplier</Link>
                    <Link to="/ebook-vip">VIP</Link>
                    <Link to="/syarat-dan-ketentuan">Syarat & Ketentuan</Link>
                    <Link to="/kebijakan-privasi">Kebijakan Privasi</Link>
                </div>
                <div className="col-6 col-sm-4 col-xl-4">
                    <div className="btn-download-apps">
                        <p>Download</p>
                        <a href="https://play.google.com/store/apps/details?id=com.application.riselio" target="_blank" rel="noopener noreferrer">
                            <img className="btn-google-play undragable" alt="Google Play" src="./assets/google-play.png" />
                        </a>
                    </div>
                    <div className="social-media-icons">
                        <p>Follow Us On</p>
                        <div>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/riselio"><img alt="Facebook" src="./assets/facebook.png" /></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/riseliocom"><img alt="Instagram" src="./assets/instagram.png" /></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/riseliocom"><img alt="twitter" src="./assets/twitter.png" /></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://wa.me/6282117203706"><img alt="whatsapp" src="./assets/whatsapp.png" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <span>version 1.11</span>
    </div>
)